import { VISITATION_TYPE_TEMPLATE } from 'app/config/visitationTypeTemplate';

export const checkImplantationVisit = padVisit => {
  const { visitationType } = padVisit;
  const { visitationTypeTemplate = {} } = visitationType;
  const templateId = visitationTypeTemplate.id || null;
  const isImplantation = templateId === VISITATION_TYPE_TEMPLATE.IMPLANTATION;

  return isImplantation;
};
